<template>
  <div>
    <div class="text-h6">Home page</div>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";

@Component
export default class Home extends Vue {}
</script>
